import { evIndustryHasForeignTradeStep } from "../../searchFlowVersionB/steps/ev/EvForeignTrade.jsx";
import GeneralError from "../../searchFlowVersionB/steps/common/GeneralError.jsx";
import RegActivityDescription from "../steps/RegActivityDescription.jsx";
import RegCompanyType from "../steps/RegCompanyType.jsx";
import RegContactPage from "../steps/RegContactPage.jsx";
import RegForeignTrade from "../steps/RegForeignTrade.jsx";
import RegIndustryActivity, {
  regIndustryHasActivityContent,
} from "../steps/RegIndustryActivity.jsx";
import RegIndustrySelect from "../steps/RegIndustrySelect.jsx";
import RegSuccessScreen from "../steps/RegSuccessScreen.jsx";
import RegTaxForm from "../steps/RegTaxForm.jsx";

/** Contact/success/error screens aren't part of the questionnaire — no progress fill there. */
const NON_PROGRESS_STEPS = new Set([RegContactPage, RegSuccessScreen, GeneralError]);

// RegContactPage is appended as a hidden cap (NON_PROGRESS_STEPS hides the bar once
// actually there) so the last *visible* form step never reaches 100% fill.
const buildRegProgressPath = (self, industry) => {
  const path = [RegIndustrySelect];
  if (regIndustryHasActivityContent(industry)) {
    path.push(RegIndustryActivity);
  }
  // RegCompanyType only shows up when arriving from CommonCompanyType's ambiguous
  // "other" pick — see regEntrySource in regFlow.jsx's constructor.
  if (self.state?.regEntrySource === "companytype") {
    path.push(RegCompanyType);
  }
  path.push(RegActivityDescription, RegTaxForm);
  if (evIndustryHasForeignTradeStep(industry)) {
    path.push(RegForeignTrade);
  }
  path.push(RegContactPage);
  return path;
};

/** Raw progress fill for a step index — recomputes from the live industry value. */
export const computeRegFlowProgressValue = (self, stepIndex, steps) => {
  const stepComponent = steps[stepIndex]?.component;
  if (!stepComponent || NON_PROGRESS_STEPS.has(stepComponent)) {
    return null;
  }

  const industry = self.props?.company_store?.industry || "";
  const path = buildRegProgressPath(self, industry);
  const pathIndex = path.indexOf(stepComponent);
  if (pathIndex === -1) {
    return null;
  }

  const totalSteps = path.length;
  return totalSteps <= 1 ? 1 : Math.min(1, Math.max(0, (pathIndex + 1) / totalSteps));
};

/**
 * RegFlow progress fill, mirroring searchFlowVersionB's ASP progress bar.
 * Value is stored on the flow instance and only updated on step navigation —
 * picking an industry with more steps (e.g. one with a foreign-trade screen) while
 * still sitting on RegIndustrySelect must not shift the bar under the user.
 */
export const getRegFlowProgress = (self, activeStep, steps) => {
  const stepComponent = steps[activeStep]?.component;
  if (!stepComponent || NON_PROGRESS_STEPS.has(stepComponent)) {
    return null;
  }

  const stored = self.state?.regProgressValue;
  const storedStep = self.state?.regProgressStep;
  if (stored != null && storedStep === activeStep) {
    return { value: stored };
  }

  const value = computeRegFlowProgressValue(self, activeStep, steps);
  if (value === null) {
    return null;
  }
  return { value };
};
